<script setup lang="ts">
import { shortId } from '../utils/string';
import { useFieldScope } from 'vince-ui/composables/useFieldScope';

const props = defineProps({
    label: {
        type: String,
        default: ''
    },
    size: {
        type: String as PropType<'small' | 'large' | undefined>,
        default: undefined
    }
});

const inputId = ref(shortId());

const trackFocusedField = useFieldScope(() => props.label);

</script>

<template>
    <label :for="inputId" style="user-select: none" @focusin="trackFocusedField">
        <VLRadioButton
            :input-id="inputId"
            :size="size"
            class="mr-1"
            v-bind="$attrs"
        />
        {{ label }}
    </label>
</template>

